/**
 * START GENAI@GHCOPILOT
 * Generates a random number string of the specified length.
 *
 * @param length The length of the random number string to generate.
 * @returns The generated random number string.
 * END GENAI@GHCOPILOT
 */
function generateRandomNumberString(length: number) {
  let result = '';
  for (let i = length; i > 0; --i) {
    result += Math.round(Math.random() * 9);
  }

  return result;
}

/**
 * START GENAI@GHCOPILOT
 * Generates a correlation ID for tracking requests.
 * The correlation ID is a combination of the current timestamp, a random number,
 * the base64-encoded hostname, and a constant string.
 *
 * @returns The generated correlation ID.
 * END GENAI@GHCOPILOT
 */
export default function createCorrelationId(): string {
  const dateString = Date.now().toString();
  const randNum = generateRandomNumberString(2);
  const base64Hostname = window.btoa(location.hostname);
  const subStrHostname = base64Hostname.substring(5, 30);
  const date1 = dateString.substring(0, 10);
  const date2 = dateString.substring(10, dateString.length);

  return `${date1}_${date2}_${randNum}_${subStrHostname}`;
}
